import React, { useEffect, useState } from "react";
import { VariantServices } from "@/types/types.ts";
import { mappedServices } from "@/utils/services/serviceMapper.ts";
import { TransformedExtendedWarranty, Services } from "@/types/serviceTypes.ts";
import { ListItem } from "@/components/__shared__/ListItem/ListItem";
import { ProtectPlusScheme } from "@/components/PostAddToBasketDrawer/scheme/schemeDecisioner.ts";
import { replaceVariables } from "@/components/PostAddToBasketDrawer/utils.ts";
import { BasketMode } from "../basketMode";
import { formatWholePounds } from "@/utils/price/formatWholePounds";

export const OPEN_POST_ADD_TO_BASKET_DRAWER = "OPEN_POST_ADD_TO_BASKET_DRAWER";
export const PRE_ADD_TO_BASKET_DRAWER = "PRE_ADD_TO_BASKET_DRAWER_OPENED";

type Props = {
  variantServices: VariantServices;
  mode: BasketMode;
  protectPlusScheme: ProtectPlusScheme;
  hasWholePoundsOnlyEnabled?: boolean;
};

function getPrice(warranty: TransformedExtendedWarranty): string {
  return warranty.display;
}

const AvailableServices = ({
  variantServices,
  mode,
  protectPlusScheme,
  hasWholePoundsOnlyEnabled = false,
}: Props) => {
  const [services, updateServices] = useState<Services>([]);

  const [isMounted, setIsMounted] = useState(false);

  useEffect(() => {
    if (variantServices) {
      const servicesMapped = mappedServices(variantServices);

      updateServices(servicesMapped);
    }
  }, [variantServices]);

  useEffect(() => {
    if (!isMounted) {
      setIsMounted(true);
      return;
    }

    const hash = window.location.hash.replace("#", "");
    const element = document.getElementById("protect-plus-item");

    if (hash && hash === "protect-plus-item" && element && isMounted) {
      window.dispatchEvent(
        new CustomEvent(
          mode === BasketMode.Pre
            ? PRE_ADD_TO_BASKET_DRAWER
            : OPEN_POST_ADD_TO_BASKET_DRAWER,
        ),
      );
    }
  }, [isMounted, mode]);

  if (!variantServices) return null;

  const warrantyServices = services.filter(
    (service) => service.serviceType === "ExtendedWarranty",
  );

  function handleClick(): void {
    window.dispatchEvent(
      new CustomEvent(
        mode === BasketMode.Pre
          ? PRE_ADD_TO_BASKET_DRAWER
          : OPEN_POST_ADD_TO_BASKET_DRAWER,
      ),
    );
  }

  return warrantyServices.map((warranty, index) => {
    return (
      <ListItem
        key={index}
        data-testid={`extended-warranty-pa2b-header-${index + 1}`}
        label="Protect Plus"
        description={replaceVariables(protectPlusScheme.schemeHighlight || "", {
          VAR_YEARS: warranty.duration,
          VAR_PRICE: formatWholePounds(
            getPrice(warranty),
            hasWholePoundsOnlyEnabled,
          ),
        })}
        showBottomBorder={true}
        showTopBorder={true}
        onClick={handleClick}
        id="protect-plus-item"
      />
    );
  });
};

export default AvailableServices;
